@if (uiAppSettings.isMaintenance === false) {
<coso-layout
  class="invisible"
  (componentLoaded)="showLayout()"
  (signOutClicked)="logout()"
  [tenantName]="tenantName$ | async"
  [userName]="username$ | async"
  [shellEndpoint]="uiAppSettings.portalEndpoint + '/shell/'"
  [identityProviderEndpoint]="uiAppSettings.authenticationClient.issuer"
  [isAuthenticated]="isAuthenticated$ | async"
  [supportsMultiTheme]="true"
  [accessTokenRetriever]="getAccessToken"
  [dashboardEndpoint]="uiAppSettings.portalEndpoint + '/dashboard/'"
>
  <ul class="navbar-nav mr-auto" slot="mainMenu">
    @if (isAuthenticated$ | async) {
    <li class="nav-item">
      <a routerLink="/configuration" class="nav-link" [class.active]="router.url.indexOf('configuration') > -1">
        <i class="fa fa-fw fa-wrench" aria-hidden="true"></i>
        Configurations
      </a>
    </li>
    } @if (isAuthenticated$ | async) {
    <li class="nav-item">
      <a routerLink="/global-settings" class="nav-link" [class.active]="router.url.indexOf('global-settings') > -1">
        <i class="fa fa-fw fa-cog" aria-hidden="true"></i>
        Global Settings
      </a>
    </li>
    }
  </ul>
  <div slot="body">
    <main id="mainContent" tabindex="-1">
      <router-outlet (activate)="onRouteActivated()"></router-outlet>
    </main>
  </div>
  <div slot="downtime-alert">
    @if (scheduledDowntime$ | async; as downtime) {
    <div class="container">
      <coso-scheduled-downtime [messageTitle]="downtime.title" [date]="downtime.scheduledDate" [message]="downtime.message"> </coso-scheduled-downtime>
    </div>
    }
  </div>
  <div slot="footer">
    @if ({ id: tenantId$ | async }; as tenant) {
    <div>
      <coso-footer
        [termsAndConditionsLink]="{
          href: uiAppSettings.portalEndpoint + '/support/SaaSServiceAgreement',
          target: '_blank'
        }"
        [contactUsLink]="{
          href: 'https://portal.connecting-software.com/support/create-case/?subjectid=46802014-8f7f-e811-8106-3863bb35af60&cs_deploymenttype=768880000&tenantid=' + tenant.id,
          target: '_blank'
        }"
        [userManualLink]="{ href: uiAppSettings.userManualUrl, target: '_blank' }"
        [releaseNotesLink]="{ routerLink: '/release-notes' }"
        [websiteLink]="{ href: 'https://www.connecting-software.com/dynamics-crm-sharepoint-permissions-replicator', target: '_blank' }"
        [blogLink]="{ href: 'https://www.connecting-software.com/blog/tag/dynamics-365', target: '_blank' }"
        [successStoriesLink]="{ href: 'https://www.connecting-software.com/dynamics-365-success-stories', target: '_blank' }"
        [shopLink]="{ href: 'https://shop.connecting-software.com/cb-dynamics-365-to-sharepoint-permissions-replicator-saas-pricing/ ', target: '_blank' }"
        [productVersion]="'2.38.0'"
        [angularRouter]="router"
      ></coso-footer>
    </div>
    }
  </div>
</coso-layout>
<coso-loading></coso-loading>
<coso-help-slider>
  <iframe [src]="uiAppSettings.portalEndpoint + '/shell/HelpSlider?serviceId=3&theme=' + (ThemeManager.instance.theme$ | async) | safe: 'resourceUrl'" title="Useful links"></iframe>
</coso-help-slider>
} @else {
<div class="container">
  <div class="d-flex header">
    <div class="col-md-12 col-lg-6">
      <div class="d-flex justify-content-lg-start justify-content-md-center">
        <img alt="connecting software logo" src="/assets/images/company-logo-big.png" class="logo-cns" />
      </div>
      <h1 class="big-error-header text-md-center text-lg-left">
        <strong>WEBSITE DOWN</strong>
      </h1>
      <div class="mt-4 text-md-center text-lg-left h3">We are in maintenance at the moment.</div>
      <div class="mt-1 text-md-center text-lg-left h3">We will be up and running shortly.</div>
      <div class="mt-1 text-md-center text-lg-left h4">Thank you for your patience!</div>
      <div class="justify-content-center d-lg-none d-md-flex">
        <img alt="Orange Robot Confused Mascot Decoration" src="/assets/images/robot-orange-light.png" />
      </div>
    </div>
    <div class="col-md-12 col-lg-6 text-md-center d-md-none d-lg-flex">
      <img alt="Orange Robot Confused Mascot Decoration" src="/assets/images/robot-orange-light.png" />
    </div>
  </div>
</div>
}
